import { i18n } from "../locales/i18n";

export class User {
    user = null;

    constructor (user) {
        this.user = user;
    }

    getName (email = false) {
        let name = "";
        if (this.user) {
            if (this.user.name) name = this.user.name;
            if (this.user.surname) {
                if (name.length > 0) name += " ";
                name += this.user.surname;
            }
            if (this.user.cif) {
                if (name.length > 0) {
                    name += "(" + this.user.cif + ")";
                } else {
                    name = this.user.cif;
                }
            }
            if (email && this.user.email) {
                if (name.length === 0) {
                    name = this.user.email;
                }
            }
        }
        return name.toUpperCase();
    }

    getSingleName () {
        let name = "";
        if (this.user) {
            if (this.user.name) name = this.user.name;
            else name = this.user.cif;
        }
        return name.toUpperCase();
    }

    getNameAndContact () {
        let name = this.getName();

        if (this.user) {
            if (this.user.email) {
                if (name.length === 0) {
                    name = this.user.email;
                } else {
                    name += " " + i18n.t('with contact') + " " + this.user.email;
                }
            }
        }
        return name;
    }
}
